// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3vQbN","row":"ProcedureTreatmentSummary_row__2yH0h"};